export const locale = {
    lang: 'ru',
    data: {
        'SYSTEM_MESSAGES': {
            'WRONG_LOGIN_OR_PWD': 'Не верный логин или пароль!',
            'WRONG_EMAIL_OR_PIN': 'Не верный email или pin-код!',
            'NEW_ASSIGNED_EVENT': 'Новое назначенное событие',
            'NEW_EMAIL': 'Новый email',
            'NEW_DOC_ADDED': 'Добавлен новый документ',
            'NEW_PAYMENT_METHOD': 'Добавлен новый способ оплаты',
            'NEW_UPCOMING_EVENT': 'Новое предстоящее событие',
            'NEW_TICKET': 'Новый тикет',
            'NEW_ASSIGNED_TICKET': 'Новый назначенный тикет',
            'CLIENT': 'Клиент',
            'LEAD': 'Лид',
            'DOC_TYPE': 'Тип документа',
            'PAYMENT_METHOD': 'Способ оплаты',
            'EVENT_TYPE': 'Событие',
            'TICKET_SUBJECT': 'Тема',
            'NEW_TICKET_MESSAGE': 'Новое сообщение к тикету',
            'MESSAGE': 'Сообщение'
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/services/i18n/ru.ts